import { KeyValue } from '@/main/models/common';
import { SummaryRequest } from '@/main/models/request/summaryRequest';
import { SummaryDataResponse } from '@/main/models/response';

export enum SummaryTypes {
  GET_SUMMARY = '@summary/GET_SUMMARY',
  SAVE_SUMMARY = '@summary/SAVE_SUMMARY',
  RESET_REDUCER_SUMMARY = '@summary/RESET_REDUCER_SUMMARY'
}

export interface SummaryState {
  readonly summary: {
    data: SummaryDataResponse | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetSummary {
  type: typeof SummaryTypes.GET_SUMMARY;
  payload: {
    request: SummaryRequest;
  };
}

export interface SaveSummary {
  type: typeof SummaryTypes.SAVE_SUMMARY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSummary {
  type: typeof SummaryTypes.RESET_REDUCER_SUMMARY;
}

export type SummaryActionTypes =
  | GetSummary
  | SaveSummary
  | ResetReducerSummary;

